import { Typography } from 'shared/components/Typography';

const RequiredText = () => (
  <Typography as="span" color="gray" fontWeight="regular" type="small">
    Required
  </Typography>
);

export default RequiredText;
